import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useOrderStatus(userId) {
  const dispatch = useDispatch();
  const { data, error, mutate } = useSWR(
    userId ? `/orderstatuses/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  useEffect(() => {
    if (error?.response && error?.response?.status > 300) {
      const messageError = `Error: ${error?.response?.status} - ${error?.response?.statusText}: OrderStatus`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    } else {
      dispatch(setSnackBar({ open: false, message: null, color: null }));
    }
  }, [error, data, dispatch]); // Ajoutez les dépendances pertinentes

  return {
    orderStatus: data?.data,
    res: {
      status: data?.code || error?.response?.status,
      statusText: data?.message || error?.response?.statusText,
    },
    mutate: mutate,
  };
}

export default useOrderStatus;
